import React, { Component, createRef } from 'react';
import * as qs from 'query-string';
import ReCAPTCHA from 'react-google-recaptcha';

import { Auth, Http } from '../../support';
import { fetchAuthMe } from '../../shared/session';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import ResponseError from '../../shared/responses/ResponseError';
import ManageCardForm from '../../shared/checkout/ManageCardForm';
import ResponseResult from '../../shared/responses/ResponseResult';

class ConfigCardAdd extends Component {

  state = {
    data: {},
  }

  recaptchaRef = null;

  constructor(props) {
    super(props);

    const { user, cliente } = Auth.getData();

    this.state = {
      data: {
        id: cliente.id,
        rfc: cliente.rfc,
        razon_social: cliente.razon_social,
        uso_cfdi: cliente.uso_cfdi,
        email: user.email,
        tarjeta: cliente.tarjeta,
        regimen: cliente.metadata.regimen,
        updated_at: cliente.updated_at,
        direccion: cliente.metadata.direccion
      }
    };

    this.recaptchaRef = createRef();
  }

  onComplete = async (info) => {
    if (!!info) {
      const original = Auth.getData();
      const { cliente } = original;

      const data = {
        ...original,
        cliente: {
          ...cliente,
          ...info,
        }
      };

      Auth.setData(data);
    }

    const query = qs.parse(this.props.location.search);

    setTimeout(() => {
      if (!!query.intro) {
        this.props.history.replace('/app/intro');
      } else {
        this.props.history.replace('/cuenta/config/activacion');
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }

  handleOnCreditCardChange = (event) => {
    this.setState({
      ...this.state,
      isValidCreditCard: event.isValid,
      payment: event.payment,
    })
  }

  handleOnSubmit = async () => {

    this.setState({ error: undefined });

    const token = await this.recaptchaRef.current.executeAsync();

    const { data } = this.state;

    const details = {
      id: data.id,
      razon_social: data.razon_social,
      email: data.email,
      rfc: data.rfc,
      challenge: token
    }

    const { error, payment } = await this.state.payment(details);

    if (error) {
      this.setState({
        ...this.state,
        error
      });

      return;
    }

    const body = {
      ...details,
      ...payment,
    }

    await this.submit(body);
  }

  async submit(data) {
    this.setState({
      busy: true
    });

    try {
      let response = await Http.put(`api/clientes/${data.id}/tarjeta`, data);

      this.setState({
        result: response
      });
    } catch (error) {
      this.setState({
        error: error.data || error
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value
      }
    });
  }

  renderResult = () => {
    const { result } = this.state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Actualización exitosa"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  handleOnAction = (action: string) => {
    if (action === 'cancel') {
      return;
    }

    this.handleSessionRefresh()

    // this.props.history.replace('/cuenta/forma-de-pago-1');
    this.setState({
      result: undefined,
      error: undefined,
    });
  }

  handleSessionRefresh = async () => {
    this.setState({
      busy: true
    });

    try {
      const original = Auth.getData();

      const response = await fetchAuthMe();

      const user = {
        ...response.data,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const { empresa, emisor, cliente } = response.data;

      const data = {
        ...original,
        user,
        empresa,
        emisor: emisor || {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setState({
        busy: false
      });

      this.props.history.push('/cuenta/licencia');
    } catch (error) {
      this.setState({
        busy: false
      });

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.message || 'Error al sincronizar tu sesión'
      });

      this.props.history.push('/bridge');
    }
  }

  render() {
    const { busy, error, result, isValidCreditCard } = this.state;

    return (
      <>
        { !!result && this.renderResult() }

        { !!error && this.renderError() }

        <PageHeader text="Mi licencia" to="/cuenta/licencia" />

        <div className="header">
          <div className="py-3">
            Esta información será usada para tus consumos y/o compras.
          </div>
        </div>

        <ReCAPTCHA
          size="invisible"
          ref={ this.recaptchaRef }
          sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
          onChange={ this.onCaptchaChange }
        />

        <ManageCardForm onChange={ this.handleOnCreditCardChange } />

        <LoadingButton type="button"
          loading={ busy }
          disabled={ !isValidCreditCard || busy }
          onClick={ this.handleOnSubmit }
        >
          { busy ? 'Registrando...' : 'Registrar Tarjeta' }
        </LoadingButton>
      </>
    )
  }
}

export default ConfigCardAdd;